import React from "react";
import DataGrid, {
  Column,
  Selection,
  FilterRow,
  Paging,
  Pager,
  Toolbar,
  Item,
} from "devextreme-react/data-grid";
import moment from "moment";
import { formatMessage } from "devextreme/localization";
import { useScreenSize } from "../../../utils/media-query";

import ToolbarBefore from "../../../components/toolbar-before/ToolbarBefore";
import ToolbarAfter from "./ToolbarAfter";
import { axios } from "../../../common";
import { useAuth } from "../../../contexts/auth";

export default function LeaveRegistrationDataTableList({
  dataGrid,
  middleware,
}) {
  const { user } = useAuth();
  const [status, setStatus] = React.useState();
  const [fromDate, setFromDate] = React.useState();
  const [toDate, setToDate] = React.useState();
  const { isXSmall, isSmall } = useScreenSize();
  const [leave, setLeave] = React.useState([]);

  const handleChangeSelectBox = async () => {
    const FromDate = moment(fromDate).format("YYYY-MM-DD");
    const ToDate = moment(toDate).format("YYYY-MM-DD");

    const payload = {
      Status: status,
      FromDate: FromDate,
      ToDate: ToDate,
      EmployeeOid: user?.EmployeeOid,
    };
    const { data } = await axios.get("LeaveRegistration", {
      params: {
        $expand: "Employee",
        $filter:
          "Employee/Oid eq " +
          user?.EmployeeOid +
          "" +
          " and FromDate ge " +
          payload.FromDate +
          "" +
          " and ToDate le " +
          payload.ToDate +
          "" +
          " and RequestStatus in [" +
          payload.Status.map((status) => `'${status}'`) +
          "]",
      },
    });
    if (!data) return;
    setLeave(data.value);
  };
  return (
    <DataGrid
      id="gridContainer"
      height={document.documentElement.offsetHeight - 189}
      showBorders={true}
      showRowLines={true}
      hoverStateEnabled={true}
      rowAlternationEnabled={true}
      columnAutoWidth={true}
      columnResizingMode="widget"
      alignment="center"
      allowColumnReordering={true}
      allowColumnResizing={true}
      columnHidingEnabled={true}
      ref={(e) => {
        dataGrid.current = e;
      }}
      dataSource={leave}
    >
      {/* <SearchPanel
        visible={true}
        width={240}
        className="datagrid-toolbar-search-panel"
        placeholder="Search..."
      /> */}

      <Selection
        mode="multiple"
        selectAllMode="page"
        showCheckBoxesMode="always"
      />
      <FilterRow visible={true} />
      <Paging defaultPageSize={10} />
      <Pager
        showPageSizeSelector={true}
        allowedPageSizes={[10, 20, 50, 100]}
        showInfo={true}
        visible={true}
      />
      <Column
        caption={formatMessage("EmployeeCode")}
        dataField="Employee.EmployeeCode"
        dataType="string"
        hidingPriority={isXSmall || isSmall ? 1 : false}
      />
      <Column
        caption={formatMessage("FullName")}
        dataField="Employee.FullName"
        dataType="string"
        hidingPriority={isXSmall || isSmall ? 1 : false}
      />
      <Column
        caption={formatMessage("LeaveSymbol")}
        dataField="Symbol.SymbolCode"
        dataType="string"
      />
      <Column
        caption={formatMessage("LeaveType")}
        dataField="LeaveType"
        dataType="string"
      />
      <Column
        caption={formatMessage("FromDate")}
        dataField="FromDate"
        dataType="date"
      />
      <Column
        caption={formatMessage("ToDate")}
        dataField="ToDate"
        dataType="date"
      />
      <Column
        caption={formatMessage("Remarks")}
        dataField="Remarks"
        dataType="string"
      />
      <Column
        caption={formatMessage("RequestStatus")}
        dataField="RequestStatus"
        dataType="string"
      />
      <Column
        caption={formatMessage("PrevApprovalName")}
        dataField="PrevApprovalName"
        dataType="string"
      />
      <Column
        caption={formatMessage("PrevApprovedDate")}
        dataField="PrevApprovedDate"
        dataType="date"
      />
      <Column
        caption={formatMessage("PrevApprovalStatus")}
        dataField="PrevApprovalStatus"
        dataType="string"
      />
      <Column
        caption={formatMessage("PrevApprovalComments")}
        dataField="PrevApprovalComments"
        dataType="string"
      />
      <Column
        caption={formatMessage("CurrentApprovalName")}
        dataField="CurrentApprovalName"
        dataType="string"
      />
      <Column
        caption={formatMessage("CancelReason")}
        dataField="CancelReason"
        dataType="string"
      />
      <Column
        caption={formatMessage("CancelDate")}
        dataField="CanceledDate"
        dataType="date"
      />
      <Toolbar className="datagrid-toolbar-actions">
        <Item
          location="before"
          locateInMenu={isXSmall || isSmall ? "always" : "auto"}
          cssClass={"datagrid-toolbar-actions-dropdown"}
        >
          <ToolbarBefore
            middleware={middleware}
            setFromDate={setFromDate}
            setToDate={setToDate}
            dataGrid={dataGrid}
            setStatus={setStatus}
            handleChangeSelectBox={handleChangeSelectBox}
          />
        </Item>
        <Item
          location="after"
          locateInMenu={isXSmall || isSmall ? "always" : "auto"}
          cssClass={"datagrid-toolbar-actions-dropdown"}
        >
          <ToolbarAfter middleware={middleware} dataGrid={dataGrid} />
        </Item>
      </Toolbar>
    </DataGrid>
  );
}
